import { em } from 'polished'
import styled from 'styled-components'

import { BoxBase } from 'styles/components/layout'
import { TextMedium } from 'styles/components/typography'
import { setBackground } from 'utils/styled/setBackground'

export const TextHighlightWrapper = styled.div`
  max-width: ${em(800)};
  margin: 0 auto ${em(20)};
  padding: 0 ${em(20)};
`

export const TextHighlight = styled(TextMedium)`
  line-height: ${p => p.theme.typography.textHighlightLh};
`

export const BoxBaseStyled = styled(BoxBase)`
  position: relative;
  background-size: cover;
  ${({ image }) => setBackground('jpg', image, { xs: 320, md: 768, lg: 1600 })};
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  padding: ${em(75)} 0;
  color: white;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: ${p => p.theme.colors.blackOp7};
  }
`

export const RelativeContainer = styled.div`
  position: relative;
  z-index: 1;
`
